import React from 'react';
import "./TechClouds.css";
import servBnr2 from "../../../assets/imgs/services/servBnr2.jpg";
import tcbnr from "../../../assets/imgs/services/tcbnr.jpg";
import ReadyToBusiness from '../../ReadyToBusiness/ReadyToBusiness';
import kardBlinkLogo from "../../../assets/imgs/logos/kard-blink-logo.png";
import Frontizo from "../../../assets/imgs/logos/frontizo_logo.png";
import timeTrack from "../../../assets/imgs/time-track.png";
import scanner from "../../../assets/imgs/scanner.png";
import dashboard from "../../../assets/imgs/dashboard.png";
import cloud from "../../../assets/imgs/cloud.png";
import webDev from "../../../assets/imgs/webDev.png";
import appDev from "../../../assets/imgs/appDev.png";
import dig from "../../../assets/imgs/digMark.png";
import erpDev from "../../../assets/imgs/erpDev.png";
import crmDev from "../../../assets/imgs/crmDev.png";
import hrMange from "../../../assets/imgs/hr-manage.png";
import control from "../../../assets/imgs/control-system.png";
import growth from "../../../assets/imgs/growth.png";
import security from "../../../assets/imgs/security.png";
import visibility from "../../../assets/imgs/visibility.png";
import scalable from "../../../assets/imgs/scalable.png";
import { Button } from "@mui/material";
import { Helmet } from "@dr.pogodin/react-helmet";
import PropTypes from "prop-types";

function TechClouds({open,  openContactForm }) {
   const handleWhatsApp = () => {
    window.open("https://wa.me/919876543210", "_blank"); 
  };

  return (
    <div className='serpMn'>
         <Helmet>
              <title>Tech Clouds & Advisory |  PAYTECH ADVISOR</title>
            </Helmet>
      <div className="tcBnr">
        <div className="maxW">
          <div className="tcBnrLft">
            <div className='tcblfCon'>
              <h1>Tech & Cloud Solutions</h1>
              <p>From Simple Builds to Enterprise Excellence.</p>
              <div className='serDtBTns'>
                <Button variant="contained" onClick={openContactForm}>
                  Enquire Now
                </Button>
             
              </div>
            </div>
          </div>
        </div>

        <div className="tcBnrRyt">
          <img src={servBnr2} alt="servBnr2" />
        </div>
      </div>

      <div className='hdPaWrp'>
        <div className="maxW">
          <h2>From Simple Builds to Enterprise Excellence</h2>
          <p>
          At Paytech Advisors, we understand that every business has unique technology needs. Our role is to connect you with the most suitable service providers and deliver technology and cloud solutions that scale with your vision. From a high-impact website to complex ERP, CRM, or cloud-based architectures, our solutions are built with performance, security, and long-term adaptability in mind.
          </p>
          <p>
          We partner with you end-to-end — from strategy to deployment. This includes assessing your requirements, designing robust systems, and implementing technology that integrates seamlessly into your operations. Whether it’s streamlining workflows, enhancing customer engagement, or migrating to the cloud, we ensure your technology investments deliver tangible business value.
          </p>
          <h3>With Paytech Advisors, technology becomes more than a tool — it’s your competitive advantage.</h3>
        </div>
      </div>

      <div className="tcmthd">
        <div className="maxW">
          <h2> Our Service Offerings</h2>
          <div className="tcmthMn">
            <div className='mths'>
                <img src={webDev} alt="webDev" />
              <h4>Web Development</h4>
              <p> Custom, scalable, and performance-driven websites</p>
            </div>

            <div className='mths'>
                    <img src={appDev} alt="appDev" />
              <h4>Mobile App Development</h4>
              <p> iOS & Android applications tailored to your business needs</p>
            </div>

            <div className='mths'>
                <img src={dig} alt="dig" />
              <h4>Digital Marketing </h4>
              <p>  SEO, SMO, and PPC campaigns to boost visibility and growth</p>
            </div>

            <div className='mths'>
                <img src={erpDev} alt="erpDev" />
              <h4>ERP Development</h4>
              <p> End-to-end enterprise resource planning solutions</p>
            </div>

            <div className='mths'>
                    <img src={crmDev} alt="crmDev" />
              <h4>CRM Development</h4>
              <p> Customer relationship management systems for stronger engagement</p>
            </div>
          </div>
        </div>
      </div>

     <div className='rdypro'>
      <div className="maxW">
         <h2> Ready-to-Deploy Products (via our Strategic Partners)</h2>

          <div className='rdpMn'>
            <div className='rdCard'>
                <div>
                    <h6>Business Management Solution</h6>
                </div>
                <div>
<p>One platform to manage people, sales, and distribution</p>
                </div>
            </div>
             <div className='rdCard'>
 <div>
                    <img src={kardBlinkLogo} alt="kardBlinkLogo" />
                </div>
                <div>
<p>Business Card Reader Mobile App</p>
                </div>
            </div>
             <div className='rdCard'>
 <div>
                    <img src={Frontizo} alt="Frontizo" />
                </div>
                <div>
<p>Complaint Management Software</p>
                </div>
            </div>
               <div className='rdCard'>
 <div>
                 <h6>Loyalty Reward Program Software</h6>
                </div>
                <div>
<p>Customer loyalty platform with instant rewards</p>
                </div>
            </div>
              
             <div className='rdCard'>
               <div>
                    <h6>Compliance Management System</h6>
                </div>
                <div>
   <p>End-to-end compliance tracking and management</p>
                </div>
              
            </div>
          </div>
      </div>
     </div>
     <div className='parDtls'>
      <div className="maxW">
        <div className="parDtMn">
          <h3>BMS: One platform to manage people, sales, and distribution — with zero hardware dependency.</h3>
          <p className='pardp'>Our Business Management Solution (BMS) is a comprehensive suite designed to simplify and automate core business operations. From HR management to sales force tracking, distribution, and inventory management, BMS gives you complete control and visibility.</p>
           <p className='pardp'>Equipped with GPS tracking capabilities and requiring no external hardware, BMS is especially suitable for businesses with field force teams, distribution channels, and related services. It helps you enhance efficiency, accountability, and productivity while reducing operational complexities.</p>
           <h3 className='keBnfts'>Key Benefits</h3>
         <div className='pardBtm'>
           <div className='bliWrp'>
             <img src={timeTrack} alt="timeTrack" />
             <h5>Real-Time Tracking</h5> 
            <p> Monitor field force activity and distribution channels with built-in GPS.</p>
          </div>
              <div className='bliWrp'>
               <img src={hrMange} alt="hrMange" />
               <h5>Simplified HR Management </h5>
            <p>Manage attendance, payroll, and employee productivity in one place.</p>
          </div>
             <div className='bliWrp'>
                 <img src={control} alt="control" />
                 <h5>Smart Inventory Control</h5> 
            <p> Track stock levels, distribution, and replenishment seamlessly.</p>
          </div>
              <div className='bliWrp'>
                   <img src={growth} alt="growth" />
                   <h5>Smart Inventory Control</h5>
            <p>Boost efficiency with structured workflows and reporting.</p>
          </div>
              <div className='bliWrp'>
                   <img src={visibility} alt="visibility" />
                   <h5>End-to-End Visibility</h5>
            <p>Gain control over operations without the need for external hardware.</p>
          </div>
           <div className='bliWrp'>
                 <img src={scalable} alt="scalable" />
                 <h5>Scalable & Flexible</h5> 
            <p>Suitable for businesses of all sizes with growing on-ground operations</p>
          </div>
         </div>
        </div>
          <div className="parDtMn">
          <h3>KardBlink : Business Card Reader Mobile App, Turn Business Cards into Business Opportunities</h3>
          <p className='pardp'>KardBlink transforms the way businesses handle contacts by instantly scanning and digitizing business cards into a secure, searchable dashboard. With private cloud hosting and advanced encryption, your data stays completely under your control — organized, protected, and always accessible. More than just storage, KardBlink turns contacts into actionable insights for sales and marketing growth.</p>
           <h3 className='keBnfts'>Key Benefits</h3>
         <div className='pardBtm'>
           <div className='bliWrp'>
             <img src={scanner} alt="scanner" />
             <h5>Instant Scanning & Digitization </h5>
            <p> Convert business cards to digital records in seconds.</p>
          </div>
              <div className='bliWrp'>
               <img src={hrMange} alt="hrMange" />
               <h5>Smart Organization</h5>
            <p> Search, filter, and access contacts easily.</p>
          </div>
             <div className='bliWrp'>
                 <img src={dashboard} alt="dashboard" />
                 <h5> Master Dashboard </h5>
            <p> Centralized view for teams and organizations.</p>
          </div>
              <div className='bliWrp'>
                   <img src={cloud} alt="cloud" />
                   <h5> Private Cloud Hosting </h5> 
            <p> Your data stays on your own server.</p>
          </div>
              <div className='bliWrp'>
                   <img src={security} alt="visibility" />
                   <h5>Data Security First </h5> 
            <p>Encryption options to protect sensitive information.</p>
          </div>
           <div className='bliWrp'>
                 <img src={scalable} alt="scalable" />
                 <h5>Business-Ready </h5> 
            <p>Perfect for marketing, sales, and customer relationship management.</p>
          </div>
         </div>
        </div>
      </div>

     </div>
      <div className='tcBnrWrp'>
        <div className="maxW">
          <img src={tcbnr} alt="tcbnr-img" />
          <p>
            By eliminating inefficiencies and driving innovation, we empower your business to scale globally, improve customer experiences, and unlock new revenue streams. With TechClouds, you gain not just cloud solutions — but a future-ready strategy.
          </p>
        </div>
      </div>

      <div>
        <ReadyToBusiness />
      </div>
    </div>
  );
}
TechClouds.propTypes = {
  open: PropTypes.bool,
  openContactForm: PropTypes.bool, 
};

TechClouds.defaultProps = {
  open: false,
  openContactForm: false,
};

export default TechClouds;
